import { useMemo } from 'react';
import {
  useEnableSessionTimeoutForLocation,
  useSessionTimeoutIdleMinsForLocation,
  useSessionTimeoutWarningDurationMinsForLocation,
} from 'api/hooks/useLocationSetting';
import useEnableSessionTimeout from './useEnableSessionTimeout';

// the timeout applies if enabled for the location, or switched on for this browser alone
export const useSessionTimeoutSettings = () => {
  const { forLocation: enabledForLocation } = useEnableSessionTimeoutForLocation();
  const [enabledOnThisBrowser] = useEnableSessionTimeout();
  const { forLocation: idleMins } = useSessionTimeoutIdleMinsForLocation();
  const { forLocation: warningMins } = useSessionTimeoutWarningDurationMinsForLocation();

  return useMemo(
    () => ({ enabled: enabledForLocation || enabledOnThisBrowser === true, idleMins, warningMins }),
    [enabledForLocation, enabledOnThisBrowser, idleMins, warningMins],
  );
};
